import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { apiUrl, apiUrlInternal, CLIENT_SECRET } from "@globalConfig";
import axios from "axios";
import { awaitTimeout, getUniversalCookieValue, getUserAgent } from "@/utils/GlobalJavascriptFunction";
import { checkTestFlag } from "@/common/config/websiteConfig";
import getInAppSource from "@/common/getInAppSource";
export var invalidateUser = function invalidateUser() {
  if (typeof window !== "undefined") {
    console.log("Your session has expired, please login again");
    window.__authContext__DONT_USE_ME_OR_YOU_WILL_BE_FIRED.reAuth();
  }
};
var checkResponseCode = function checkResponseCode(response, code) {
  var _response$data;
  return (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === code || (response === null || response === void 0 ? void 0 : response.status) === code;
};
var shouldInvalidateUser = function shouldInvalidateUser(response) {
  var WHITELIST_PATHS = ['logout', 'search/track'
  // 'customer/list-favourite'
  ];
  var responseStr = JSON.stringify(response);
  return !WHITELIST_PATHS.some(function (path) {
    return responseStr.includes(path);
  });
};
export var is422 = function is422(response) {
  return checkResponseCode(response, 422);
};
export var isUnauthorized = function isUnauthorized(response) {
  return [401, 403].some(function (code) {
    return checkResponseCode(response, code);
  });
};
export var isNotSuccess = function isNotSuccess(response) {
  var _response$data2, _response$data3;
  return (response === null || response === void 0 ? void 0 : response.status) >= 400 || (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code) >= 400 || (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.success) === false;
};
export var extractLangFromReq = function extractLangFromReq(req) {
  if (__IS_CSR__) {
    return window.location.pathname.match(/^(\/en)/) ? "en" : "ar";
  }
  return req ? "".concat(req.language) : "ar";
};
export var createAxiosInstance = function createAxiosInstance(req) {
  var _req$headers, _req$headers2, _req$headers3;
  var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'syarah_v1';
  var isJsonContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var token = getUniversalCookieValue(req, "accessToken");
  var userAgent = req ? getUserAgent(req) + ' SSR' : getUserAgent(req);
  var UUID = getUniversalCookieValue(req, "UUID", "UA-" + getUserAgent(req));
  var ggbuid = getUniversalCookieValue(req, "gbuuid", "".concat(new Date().getTime(), "-").concat(Math.floor(Math.random() * 100000)));
  var lang = extractLangFromReq(req);
  var inAppSource = getInAppSource(req);
  var inAppSourceData = {};
  if (inAppSource && inAppSource.platform) {
    inAppSourceData = {
      'webview-app-source': inAppSource.platform,
      'webview-app-version': inAppSource.version || "unknown"
    };
  }
  var baseURL = req ? "".concat(apiUrlInternal.replace('syarah_v1', basePath), "/").concat(lang) : "".concat(apiUrl.replace('syarah_v1', basePath), "/").concat(lang);
  // get Ip address from express request, or cloudflare headers
  var remoteIp = (req === null || req === void 0 ? void 0 : (_req$headers = req.headers) === null || _req$headers === void 0 ? void 0 : _req$headers["cf-connecting-ip"]) || (req === null || req === void 0 ? void 0 : (_req$headers2 = req.headers) === null || _req$headers2 === void 0 ? void 0 : _req$headers2["x-forwarded-for"]) || (req === null || req === void 0 ? void 0 : (_req$headers3 = req.headers) === null || _req$headers3 === void 0 ? void 0 : _req$headers3["x-real-ip"]) || null;
  var headers = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, !token ? "" : {
    Authorization: "Bearer ".concat(token)
  }), {}, {
    token: CLIENT_SECRET,
    "Content-Type": isJsonContentType ? "application/json" : "application/x-www-form-urlencoded",
    Accept: "application/json",
    "user-id": UUID,
    "gbuuid": ggbuid,
    device: "web",
    "Accept-EnhancedStatusCodes": 1
  }, remoteIp ? {
    "x-secret-forwarded-ip": remoteIp
  } : {}), inAppSourceData), {}, {
    'User-Agent': userAgent
  });
  var axiosInstance = axios.create({
    baseURL: baseURL,
    headers: headers
  });
  return axiosInstance;
};

/**
 *
 * @param {import('express').Request} [req] - The optional Express request object
 * @param isJsonContentType
 * @returns {import('axios').AxiosInstance}
 */
var createFetcher = function createFetcher() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var isJsonContentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (req && req.axiosInstance) {
    return req.axiosInstance;
  }
  var axiosInstance = createAxiosInstance(req, "syarah_v1", isJsonContentType);
  axiosInstance.interceptors.response.use(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(response) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(__IS_CSR__ && checkTestFlag("TEST_DELAY_API_TIME__3000"))) {
              _context.n = 1;
              break;
            }
            _context.n = 1;
            return awaitTimeout(3000);
          case 1:
            if (!(__IS_CSR__ && checkTestFlag("TEST_DELAY_API_TIME__60000"))) {
              _context.n = 2;
              break;
            }
            _context.n = 2;
            return awaitTimeout(60000);
          case 2:
            if (!(__IS_CSR__ && checkTestFlag("TEST_API_500"))) {
              _context.n = 3;
              break;
            }
            console.log("Simulated 500 Internal Server Error (syarah_v1)");
            throw new Error("Simulated 500 Internal Server Error (syarah_v1)");
          case 3:
            if (!(isUnauthorized(response) && shouldInvalidateUser(response))) {
              _context.n = 4;
              break;
            }
            return _context.a(2, invalidateUser());
          case 4:
            return _context.a(2, response);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), function (error) {
    var _error$response, _error$response$data;
    console.error("-> Axios error1", error);
    if (isUnauthorized(error === null || error === void 0 ? void 0 : error.response) && shouldInvalidateUser(error === null || error === void 0 ? void 0 : error.response)) {
      return invalidateUser();
    }
    // just in case the status code is not 230!
    if (error !== null && error !== void 0 && (_error$response = error.response) !== null && _error$response !== void 0 && (_error$response$data = _error$response.data) !== null && _error$response$data !== void 0 && _error$response$data.validation_errors) {
      var _error$response2, _error$response2$data;
      var errorMessagesArray = Object.values((error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.validation_errors) || {});
      if (Array.isArray(errorMessagesArray) && errorMessagesArray.length > 0) {
        var message = errorMessagesArray.join("\n ");
        return Promise.reject({
          message: message
        });
      } else {
        var _error$response3, _error$response3$data;
        var _message = JSON.stringify((error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.validation_errors) || {});
        return Promise.reject({
          message: _message
        });
      }
    }
    // on server side, we need to reject the promise
    if (req) {
      return Promise.reject(error);
    }
    return Promise.resolve(error);
  });
  if (req && req !== null && req !== void 0 && req.axiosInstance) {
    req.axiosInstance = axiosInstance;
  }
  return axiosInstance;
};
export default createFetcher;